import { Dispatch } from 'redux'
import * as MyScopesApi from 'redux/api/MyScopes'

import * as myScopesActions from './actions'

import { useThunkActions } from 'redux/actions/useThunkActions'

export function tryGetMyScopes() {
  return (dispatch: Dispatch) => {
    dispatch(myScopesActions.getAll())

    MyScopesApi.getAll()
      .then((response) => {
        dispatch(myScopesActions.getAllSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(myScopesActions.getAllFailed())
      })
  }
}

export function tryUpdateMyScopes(names: string[]) {
  return (dispatch: Dispatch) => {
    dispatch(myScopesActions.update())

    MyScopesApi.update(names)
      .then((response) => {
        dispatch(myScopesActions.updateSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(myScopesActions.updateFailed())
      })
  }
}

export const useMyScopeActions = () => {
  return {
    tryGetMyScopes: useThunkActions(tryGetMyScopes),
    tryUpdateMyScopes: useThunkActions(tryUpdateMyScopes)
  }
}
